import React from 'react';
import { useTheme } from '../context/ThemeContext';

export default function ThemeSwitcher({ size = 'md' }) {
  const { theme, setTheme } = useTheme();
  const s = size === 'sm' ? 22 : 28;
  return (
    <div style={{ display:'flex', gap:6, alignItems:'center' }}>
      {[
        { key:'blue',   bg:'linear-gradient(135deg,#3b82f6,#06b6d4)', title:'Blue' },
        { key:'orange', bg:'linear-gradient(135deg,#f97316,#fbbf24)', title:'Orange' },
        { key:'green',  bg:'linear-gradient(135deg,#22c55e,#34d399)', title:'Green' },
      ].map(t => (
        <button
          key={t.key}
          title={`${t.title} theme`}
          onClick={() => setTheme(t.key)}
          style={{
            width: s, height: s,
            borderRadius: '50%',
            border: theme === t.key ? '3px solid var(--text)' : '2px solid transparent',
            background: t.bg,
            cursor: 'pointer',
            boxShadow: theme === t.key ? '0 0 0 2px var(--primary)' : 'none',
            transform: theme === t.key ? 'scale(1.15)' : 'scale(1)',
            transition: 'all .2s',
            flexShrink: 0,
          }}
        />
      ))}
    </div>
  );
}
